module.exports = __webpack_public_path__ + "img/imdb-black.48701e5b.svg";